import { AccountMenu } from "./components/AccountMenu";
import { navigate, parseRoute, usePathname } from "./lib/router";
import { PlannerPage } from "./pages/PlannerPage";
import { RaceCardPage } from "./pages/RaceCardPage";
import { SharedPlanPage, SharedRaceCardPage } from "./pages/SharedPlanPage";
import { useActivePlan } from "./store";

function ActivePlanRaceCard() {
  return <RaceCardPage plan={useActivePlan()} backTo="/" />;
}

function NotFound() {
  return (
    <div className="card mx-auto mt-8 max-w-md p-6 text-center">
      <h1 className="text-lg font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-ink-2">
        Check the link, or if you have a share code, make sure it's typed correctly.
      </p>
      <button type="button" className="btn btn-primary mt-4" onClick={() => navigate("/")}>
        Go to the planner
      </button>
    </div>
  );
}

export function App() {
  const route = parseRoute(usePathname());

  return (
    <div className="min-h-dvh">
      <header className="border-b border-line bg-surface print:hidden">
        <div className="mx-auto flex max-w-6xl items-center gap-2 px-4 py-3">
          <a
            href="/"
            className="flex items-center gap-2"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
          >
            <img src="/favicon.svg" alt="" className="size-7" />
            <span className="text-lg font-semibold tracking-tight">RoxPacer</span>
          </a>
          <span className="hidden text-sm text-muted lg:inline">Hyrox race planner</span>
          <div className="ml-auto">
            <AccountMenu />
          </div>
        </div>
      </header>

      {route.name === "planner" && <PlannerPage />}
      {route.name === "race-card" && <ActivePlanRaceCard />}
      {route.name === "shared" && <SharedPlanPage code={route.code} />}
      {route.name === "shared-race-card" && <SharedRaceCardPage code={route.code} />}
      {route.name === "not-found" && <NotFound />}
    </div>
  );
}
